var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgGdpr = function SvgGdpr(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 113.948 182.853"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 18961"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#262f4d",
    d: "M36.422 163.703v-12.8H24.234v4.525h7.191c-.3 1.351-1.958 3.916-5.908 3.916-3.883 0-7.191-2.6-7.191-7.6 0-5.335 3.815-7.5 7.056-7.5a5.766 5.766 0 0 1 5.942 4.187l5.132-1.789c-1.047-3.342-4.22-7.394-11.074-7.394a12.164 12.164 0 0 0-12.458 12.492c0 7.563 5.47 12.458 12.121 12.458 3.41 0 5.672-1.418 6.719-2.937l.338 2.431Zm8.848-5.031v-13.876h3.105c3.68 0 6.685 2.161 6.685 6.955s-3 6.921-6.685 6.921Zm3.309 5.031c7.225 0 12.053-4.558 12.053-11.952s-4.828-11.986-12.02-11.986h-8.677v23.938Zm20.507-13.2v-6.111h3.106c2.026 0 3.41 1.148 3.41 3.072 0 1.857-1.384 3.039-3.41 3.039Zm3.646 4.592c4.862 0 8.2-3.14 8.2-7.664 0-4.457-3.343-7.664-8.2-7.664h-9.015v23.938h5.335v-8.61Zm22.192 8.61h5.875l-4.862-9.69a6.866 6.866 0 0 0 4.727-6.753c0-4.254-3.039-7.5-7.765-7.5h-9.487V163.7h5.335v-8.913h1.891Zm-6.179-13.507v-5.807h3.14c2.195 0 3.376 1.114 3.376 2.9 0 1.688-1.182 2.9-3.376 2.9Z",
    "data-name": "Path 32195"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 18470"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#262f4d",
    d: "M29.673 182.853a3.357 3.357 0 0 0 3.387-2.479l-1.161-.38a2.233 2.233 0 0 1-2.226 1.646 2.706 2.706 0 0 1-.011-5.391 2.075 2.075 0 0 1 2.173 1.635l1.192-.4a3.258 3.258 0 0 0-3.366-2.427 3.747 3.747 0 0 0-3.767 3.9 3.7 3.7 0 0 0 3.779 3.896m5.444-3.9a2.513 2.513 0 1 1 2.5 2.7 2.493 2.493 0 0 1-2.5-2.704Zm-1.3 0a3.8 3.8 0 1 0 3.8-3.893 3.747 3.747 0 0 0-3.797 3.889Zm17.235 3.744v-7.481h-1.72l-2.4 5.708-2.427-5.708h-1.688v7.481h1.234v-5.486l2.311 5.486h1.1l2.332-5.508v5.508Zm3.144-4.041v-2.321h1.319a1.167 1.167 0 1 1 0 2.321Zm1.509 1.118a2.281 2.281 0 1 0 0-4.558H52.93v7.481h1.266v-2.923Zm8.309 2.923v-1.2h-3.429v-6.278h-1.263v7.478Zm2.4 0v-7.481h-1.287v7.481Zm6.983 0h1.382l-2.912-7.481H70.4l-2.912 7.481h1.34l.7-1.878h3.165Zm-2.29-6.109 1.14 3.06h-2.279Zm11.024 6.109v-7.481h-1.266v5.307l-3.4-5.307h-1.614v7.481h1.266v-5.666l3.693 5.666Zm7.253-6.288v-1.192h-6.13v1.192h2.427v6.288h1.271v-6.29Z",
    "data-name": "Path 32194"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffde06",
    d: "m56.977.001 1.845 5.841h5.974l-4.832 3.609 1.845 5.841-4.832-3.612-4.832 3.612 1.846-5.841-4.834-3.609h5.974Z",
    "data-name": "Path 32196"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffde06",
    d: "m56.977 96.119 1.845 5.842h5.974l-4.832 3.609 1.845 5.839-4.832-3.608-4.832 3.608 1.846-5.839-4.834-3.609h5.974Z",
    "data-name": "Path 32197"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffde06",
    d: "m81.55 8.74 1.844 5.841h5.975l-4.833 3.611 1.846 5.84-4.832-3.612-4.834 3.612 1.846-5.84-4.832-3.611h5.975Z",
    "data-name": "Path 32198"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffde06",
    d: "m101.658 25.305 1.844 5.841h5.975l-4.833 3.61 1.846 5.84-4.832-3.609-4.833 3.609 1.846-5.84-4.833-3.61h5.973Z",
    "data-name": "Path 32199"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffde06",
    d: "m101.658 72.088 1.845 5.842h5.974l-4.833 3.609 1.847 5.84-4.833-3.608-4.833 3.608 1.846-5.84-4.833-3.609h5.974Z",
    "data-name": "Path 32200"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffde06",
    d: "m12.285 25.305 1.845 5.841h5.974l-4.833 3.61 1.845 5.84-4.831-3.609-4.834 3.609 1.846-5.84-4.833-3.61h5.976Z",
    "data-name": "Path 32201"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffde06",
    d: "m106.133 48.06 1.845 5.84h5.974l-4.833 3.609 1.846 5.841-4.832-3.607-4.833 3.607 1.847-5.841-4.834-3.609h5.973Z",
    "data-name": "Path 32202"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffde06",
    d: "m7.821 48.06 1.844 5.84h5.974l-4.833 3.609 1.847 5.841-4.832-3.607-4.834 3.607 1.846-5.841L0 53.9h5.975Z",
    "data-name": "Path 32203"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffde06",
    d: "m12.285 72.088 1.845 5.842h5.974l-4.832 3.609 1.844 5.84-4.831-3.608-4.833 3.608 1.846-5.84-4.834-3.609h5.976Z",
    "data-name": "Path 32204"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffde06",
    d: "m86.02 91.748 1.845 5.839h5.974l-4.834 3.612 1.847 5.84-4.832-3.608-4.834 3.608 1.847-5.84-4.833-3.612h5.975Z",
    "data-name": "Path 32205"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffde06",
    d: "m32.393 8.74 1.844 5.841h5.975l-4.833 3.611 1.847 5.84-4.833-3.612-4.832 3.612 1.845-5.84-4.833-3.611h5.974Z",
    "data-name": "Path 32206"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffde06",
    d: "m27.929 91.748 1.845 5.842h5.977l-4.833 3.608 1.846 5.84-4.833-3.606-4.832 3.606 1.845-5.84-4.832-3.608h5.973Z",
    "data-name": "Path 32207"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0068ff",
    d: "M56.749 42.645a12.868 12.868 0 1 0 12.868 12.868 12.882 12.882 0 0 0-12.868-12.868m-.373 18.723a1.611 1.611 0 0 1-1.163.577h-.072a1.607 1.607 0 0 1-1.137-.471l-3.217-3.217 2.275-2.274 1.972 1.972 6.915-8.3 2.471 2.059Zm0 0",
    "data-name": "Path 32221"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0068ff",
    d: "m80.627 39.285-23.1-12.7a1.609 1.609 0 0 0-1.55 0l-23.1 12.7a1.607 1.607 0 0 0-.826 1.549l1.38 15.863a26.97 26.97 0 0 0 11.803 20.088l10.616 7.177a1.614 1.614 0 0 0 1.8 0l10.616-7.178a26.969 26.969 0 0 0 11.809-20.086l1.38-15.863a1.615 1.615 0 0 0-.828-1.55M56.749 71.596a16.085 16.085 0 1 1 16.085-16.085 16.1 16.1 0 0 1-16.085 16.085m0 0",
    "data-name": "Path 32222"
  })))));
};
export default SvgGdpr;